import { resolvePlaybackResumePositionMs } from "./resumeCheckpoint";

type RestorePlaybackResumeArgs = {
  resume: Pick<
    import("./resumeCheckpoint").ResumeCheckpoint,
    "clearPlaybackResumeCheckpoint" | "readPlaybackResumeCheckpoint"
  >;
  queueType: "foryou" | "playlist";
  currentItem: {
    qid: string;
    metadata: { id: string; duration?: number };
  };
  nativeTrackId: string | null;
  seek: (positionSeconds: number) => Promise<void>;
};

export type RestorePlaybackResumeResult =
  | { status: "none" | "native-active" | "rejected" }
  | { status: "restored"; positionMs: number };

export async function restorePlaybackResume({
  resume,
  queueType,
  currentItem,
  nativeTrackId,
  seek,
}: RestorePlaybackResumeArgs): Promise<RestorePlaybackResumeResult> {
  if (nativeTrackId) return { status: "native-active" };

  const checkpoint = resume.readPlaybackResumeCheckpoint(queueType);
  if (!checkpoint) return { status: "none" };

  const positionMs = resolvePlaybackResumePositionMs(checkpoint, {
    songId: currentItem.metadata.id,
    queueItemId: currentItem.qid,
    durationMs: (currentItem.metadata.duration ?? 0) * 1000,
  });
  if (positionMs == null) {
    resume.clearPlaybackResumeCheckpoint(queueType);
    return { status: "rejected" };
  }

  await seek(positionMs / 1000);
  return { status: "restored", positionMs };
}
